export default function isNegativeZero(value) {
  return 1 / value === -Infinity;
}